import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { getEasternGreeting, formatEasternDateOnly } from '../../../utils/timezone';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const AdminWelcomeHeader = () => {
  const { userProfile, user } = useAuth();

  const currentDate = formatEasternDateOnly(new Date(), {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const getWelcomeMessage = () => {
    const role = userProfile?.role || 'admin';
    switch (role) {
      case 'admin':
        return 'Admin Portal Dashboard';
      case 'hr_manager':
        return 'HR Management Dashboard';
      case 'supervisor':
        return 'Supervisor Dashboard';
      default:
        return 'Management Dashboard';
    }
  };

  const getRoleIcon = () => {
    const role = userProfile?.role || 'admin';
    switch (role) {
      case 'admin':
        return 'Shield';
      case 'hr_manager':
        return 'Users';
      case 'supervisor':
        return 'UserCheck';
      default:
        return 'Settings';
    }
  };

  const getGreeting = () => {
    return getEasternGreeting();
  };

  return (
    <div className="bg-card rounded-lg border border-border card-shadow p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        {/* Admin Info Section */}
        <div className="flex items-center space-x-4 mb-4 lg:mb-0">
          <div className="relative">
            <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-primary/20 bg-primary/10">
              {userProfile?.avatar_url ? (
                <Image
                  src={userProfile?.avatar_url}
                  alt={`${userProfile?.full_name || 'Admin'} profile picture`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <Icon name={getRoleIcon()} size={24} color="var(--color-primary)" />
                </div>
              )}
            </div>
            <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-primary rounded-full border-2 border-card flex items-center justify-center">
              <Icon name="Crown" size={10} color="white" />
            </div>
          </div>
          
          <div className="flex-1">
            <div className="flex items-center space-x-2 mb-1">
              <h1 className="text-2xl font-semibold text-foreground">
                {getGreeting()}, {userProfile?.full_name || user?.email?.split('@')?.[0] || 'Admin'}! 👋
              </h1>
              <Icon name="Settings" size={20} color="var(--color-primary)" />
            </div>
            <p className="text-primary text-sm mb-1 font-medium">
              {getWelcomeMessage()}
            </p>
            <p className="text-xs text-muted-foreground">
              {currentDate} • Role: {userProfile?.role?.toUpperCase() || 'ADMIN'}
            </p>
          </div>
        </div>

        {/* Admin Quick Stats */}
        <div className="grid grid-cols-3 gap-3 lg:gap-4">
          <div className="bg-primary/5 rounded-lg p-3 text-center border border-primary/10">
            <div className="flex items-center justify-center mb-1">
              <Icon name="Users" size={16} color="var(--color-primary)" />
            </div>
            <p className="text-lg font-semibold text-primary">--</p>
            <p className="text-xs text-muted-foreground">Employees</p>
          </div>
          
          <div className="bg-warning/5 rounded-lg p-3 text-center border border-warning/10">
            <div className="flex items-center justify-center mb-1">
              <Icon name="AlertCircle" size={16} color="var(--color-warning)" />
            </div>
            <p className="text-lg font-semibold text-warning">--</p>
            <p className="text-xs text-muted-foreground">Pending</p>
          </div>
          
          <div className="bg-success/5 rounded-lg p-3 text-center border border-success/10">
            <div className="flex items-center justify-center mb-1">
              <Icon name="TrendingUp" size={16} color="var(--color-success)" />
            </div>
            <p className="text-lg font-semibold text-success">--</p>
            <p className="text-xs text-muted-foreground">Attendance</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminWelcomeHeader;